import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { BitmapText, Container } from "pixi.js";
import { DisplayObject, IDisplayObject } from "../../core/displays/DisplayObject";
import { Manager } from "../../core/Manager";

export class JpMeter extends DisplayObject {
    private jackpotPanelContainer = new Container();
    private maxWinContainer = new Container();
    private megaWinContainer = new Container();
    private majorWinContainer = new Container();
    private miniWinContainer = new Container();

    private maxWin: Spine | null = null;
    private megaWin: Spine | null = null;
    private majorWin: Spine | null = null;
    private miniWin: Spine | null = null;

    constructor(config: IDisplayObject) {
        super(config);
        this.init();
        this.setPositionResize(Manager.Orientation || "LANDSCAPE");
    }

    private init(): void {
        //Max Win
        this.maxWin = Spine.from({
            skeleton: "maxWinMeterSkel",
            atlas: "maxWinMeterAtlas"
        })
        this.maxWin.position.set(-65, 70);
        this.maxWin.label = "Max Win";
        this.maxWin.state.setAnimation(0, "idle", false);
        this.maxWinContainer.addChild(this.maxWin);

        const maxLabel = new BitmapText({
            text: '10000X',
            style: { fontFamily: 'witch_jackpotPanel_amount', fontSize: 55 },
        });
        maxLabel.anchor.set(0.5);
        maxLabel.position.set(-60, 75);
        this.maxWinContainer.addChild(maxLabel);

        //Mega
        this.megaWin = Spine.from({
            skeleton: "megaWinMeterSkel",
            atlas: "megaWinMeterAtlas"
        })
        this.megaWin.position.set(-50, 85);
        this.megaWin.label = "Mega Win";
        this.megaWin.state.setAnimation(0, "idle", false);
        this.megaWinContainer.addChild(this.megaWin);
        //mega text 
        const megaLabel = new BitmapText({
            text: '1000X',
            style: { fontFamily: 'witch_jackpotPanel_amount', fontSize: 52 },
        });
        megaLabel.anchor.set(0.5);
        megaLabel.position.set(-45, 90);
        this.megaWinContainer.addChild(megaLabel);


        //Major
        this.majorWin = Spine.from({
            skeleton: "majorWinMeterSkel",
            atlas: "majorWinMeterAtlas"
        })
        this.majorWin.position.set(-40, 100);
        this.majorWin.label = "Major Win";
        this.majorWin.state.setAnimation(0, "idle", false);
        this.majorWinContainer.addChild(this.majorWin);
        //major text
        const majorLabel = new BitmapText({
            text: '100X',
            style: { fontFamily: 'witch_jackpotPanel_amount', fontSize: 50 },
        });
        majorLabel.anchor.set(0.5);
        majorLabel.position.set(-40, 105);
        this.majorWinContainer.addChild(majorLabel);

        //Mini
        this.miniWin = Spine.from({
            skeleton: "miniWinMeterSkel",
            atlas: "miniWinMeterAtlas"
        })
        this.miniWin.position.set(-32, 105);
        this.miniWin.label = "Mini Win";
        this.miniWin.state.setAnimation(0, "idle", false);
        this.miniWinContainer.addChild(this.miniWin);
        // mini text
        const miniLabel = new BitmapText({
            text: '10X',
            style: { fontFamily: 'witch_jackpotPanel_amount', fontSize: 48 },
        });
        miniLabel.anchor.set(0.5);
        miniLabel.position.set(-30, 107);
        this.miniWinContainer.addChild(miniLabel);


        this.jackpotPanelContainer.addChild(this.maxWinContainer);
        this.jackpotPanelContainer.addChild(this.megaWinContainer);
        this.jackpotPanelContainer.addChild(this.majorWinContainer);
        this.jackpotPanelContainer.addChild(this.miniWinContainer);

        this.jackpotPanelContainer.position.set(750, 1350);
        this.jackpotPanelContainer.label = "Jackpot Panel Container";
        this.addChild(this.jackpotPanelContainer);
    }

    protected playJackpotPanelAnimation(symbolId: number): void {
        // here resolve is a function type ()
        console.log("inside playJackpotPanelAnimation");

        switch (symbolId) {
            case 16:
                this.miniWin?.state.setAnimation(0, "win", false);
                break;
            case 17:
                this.majorWin?.state.setAnimation(0, "win", false);
                break;
            case 18:
                this.megaWin?.state.setAnimation(0, "win", false);
                break;
            case 19:
                this.maxWin?.state.setAnimation(0, "win", false);
                break;

            default:
                break;
        }
    }

    public override setPositionResize(orientation: string): void {


        if (orientation === "LANDSCAPE") {
            this.setPosition(this.config.landscape.posX, this.config.landscape.posY);
            this.setScale(this.config.landscape.scale, this.config.landscape.scale);
            this.maxWinContainer?.position.set(0, 0);
            this.megaWinContainer?.position.set(15, 145);
            this.majorWinContainer?.position.set(20, 279);
            this.miniWinContainer?.position.set(25, 417);
            this.jackpotPanelContainer?.scale.set(0.8)
            this.jackpotPanelContainer?.position.set(760, 1300);
        } else {
            this.setPosition(this.config.portrait.posX, this.config.portrait.posY);
            this.setScale(this.config.portrait.scale, this.config.portrait.scale);
            this.maxWinContainer?.position.set(0, 0);
            this.megaWinContainer?.position.set(950, 0);
            this.majorWinContainer?.position.set(20, 155);
            this.miniWinContainer?.position.set(970, 155);
            this.jackpotPanelContainer?.scale.set(0.8)
            this.jackpotPanelContainer?.position.set(1020, 750);
        }
    }
}